import { render, staticRenderFns } from "./editOrgaManagerRoot.vue?vue&type=template&id=4542af2c&scoped=true"
import script from "./editOrgaManagerRoot.vue?vue&type=script&lang=js"
export * from "./editOrgaManagerRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4542af2c",
  null
  
)

export default component.exports